import { render, staticRenderFns } from "./BulkAssignPackageDialog.vue?vue&type=template&id=0ccbc7a1"
import script from "./BulkAssignPackageDialog.vue?vue&type=script&lang=js"
export * from "./BulkAssignPackageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccbc7a1')) {
      api.createRecord('0ccbc7a1', component.options)
    } else {
      api.reload('0ccbc7a1', component.options)
    }
    module.hot.accept("./BulkAssignPackageDialog.vue?vue&type=template&id=0ccbc7a1", function () {
      api.rerender('0ccbc7a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/BulkAssignPackageDialog.vue"
export default component.exports